import {
    PayPalButtons,
    PayPalScriptProvider,
    usePayPalScriptReducer,
} from "@paypal/react-paypal-js";
import { useEffect, useState } from "react";
const style = { layout: "vertical" };
const ButtonWrapper = ({ showSpinner, onPurchaseSuccess, amount }) => {
    const [{ isPending }] = usePayPalScriptReducer();
    const [currentAmount, setCurrentAmount] = useState(0);
    const [loader, setLoader] = useState(false);
    useEffect(() => {
        setLoader(false);
        setCurrentAmount(amount);
        setTimeout(() => {
            setLoader(true);
        }, 5);
    }, [amount]);
    return (
        <>
            {showSpinner && isPending && <div className="spinner" />}
            {currentAmount && loader && (
                <PayPalButtons
                    style={style}
                    disabled={false}
                    forceReRender={[style]}
                    fundingSource="paypal"
                    createOrder={async (data, actions) => {
                        return await actions.order.create({
                            purchase_units: [
                                {
                                    amount: {
                                        value: currentAmount?.toFixed(2),
                                    },
                                },
                            ],
                        });
                    }}
                    onApprove={async (data, actions) => {
                        try {
                            const order = await actions.order.capture();
                            await onPurchaseSuccess(order);
                        } catch (e) {
                            console.log("reject");
                        }
                    }}
                    onError={(e) => console.log("reject")}
                />
            )}
        </>
    );
};
export default function Paypal(props) {
    return (
        <div style={{ maxWidth: "750px", minHeight: "35px" }} className="mx-3">
            <PayPalScriptProvider
            // options={{
            // clientId:
            //     "ATQKSOirZKmAFy1It6rj0vvHU1EoTeUXDTWSUYaRrOOsR8ZopGQYs0hGGL-VBb9R7igkthwrjRvVMpCB",
            //     components: "buttons",
            //     currency: "USD",
            // }}
            >
                <ButtonWrapper
                    amount={props?.amount}
                    showSpinner={false}
                    onPurchaseSuccess={props.onPurchaseSuccess}
                />
            </PayPalScriptProvider>
        </div>
    );
}
